import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { createDepartment, deleteDepartment, fetchAllDepartments, updateDepartment, } from "../../../core/data/redux/department/departmentAction";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../core/data/redux/store";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../core/common/GlobalFunctions/exportTableData";
import { Col, Drawer, message } from "antd";
import { status as DepartmentStatus } from "../../../core/common/selectoption/selectoption";
import { decryptData } from "../../../core/utils/encryptUtils";
import Select from "react-select";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
import { set } from "react-datepicker/dist/date_utils";

const Department = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [departmentName, setDepartmentName] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [departmentDescription, setDepartmentDescription] = useState<string>("");
  const [hrId, setHrId] = useState<string[]>([]);
  const { user } = useSelector((state: any) => state.auth);
  const { departments, loading } = useSelector((state: any) => state.department);
  const departmentId = selectedRowData?.Id;
  const [errors, setErrors] = useState<any>({});
  const { employees } = useSelector((state: RootState) => state.employee);
  const activeEmployees = filterByStatus(employees, 'active', 'employee_status')

  const formattedEmployees = activeEmployees.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name
  }))

  const handleHrChange = (selectedOptions: any) => {
    setHrId(selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []);
  };


  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");

  const resetFields = () => {
    setDepartmentName("");
    setDepartmentDescription("");
    setHrId([]);
    setSelectedRowData(null);
  };
  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
    setErrors({});
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetFields();
    setErrors({});
  };

  const handleEditDepartment = (record: any): void => {
    setSelectedRowData(record);
  };

  useEffect(() => {
    if (!departments.length) {
      dispatch(fetchAllDepartments());
    }
  }, [departments.length, dispatch]);

  useEffect(() => {
    if (!employees.length) {
      dispatch(getEmployees())
    }
  })

  useEffect(() => {
    if (modalType === "edit" && departmentId) {
      setDepartmentName(selectedRowData?.Name);
      setDepartmentDescription(selectedRowData?.Description);
      setStatus(selectedRowData?.Status);
      setHrId(selectedRowData?.hrId);
    }
  }, [departmentId, modalType, selectedRowData]);

  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      Name: "",
      Description: "",
    };

    if (!departmentName) {
      formIsValid = false;
      newErrors.Name = "Department name is required.";
    }

    if (!status) {
      formIsValid = false;
      newErrors.status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const departmentData = {
      Name: departmentName,
      Description: departmentDescription,
      hrId: hrId,
      Status: status,
      CreatedBy: user?.UserId,
      ModifiedBy: user?.UserId,
    };

    try {
      let result;
      if (modalType === "create") {
        result = await dispatch(createDepartment(departmentData));
        console.log(result, "result");
        if (result.meta.requestStatus === "fulfilled") {
          message.success("Department created successfully");
          await dispatch(fetchAllDepartments());
          setTableKey((prevKey) => prevKey + 1);
          resetFields();
        } else if (result.meta.requestStatus === "rejected") {
          message.error(result.payload.error);
        }
      } else if (modalType === "edit" && departmentId) {
        const updateData = { ...departmentData, departmentId: departmentId };
        result = await dispatch(updateDepartment(updateData));

        if (result.meta.requestStatus === "fulfilled") {
          message.success("Department updated successfully");
          resetFields();
          await dispatch(fetchAllDepartments());
          setTableKey((prevKey) => prevKey + 1);
        } else if (result.meta.requestStatus === "rejected") {
          message.error(result.payload.error);
        }
      }
      handleCancel();
    } catch (error) {
      message.error("Something went wrong");
    }
  };

  const handleDeleteDepartment = async (departmentId: number) => {
    try {
      const result = await dispatch(deleteDepartment({ departmentId }));
      if (result.meta.requestStatus === "fulfilled") {
        message.success(result.payload.message);
        setIsDeleteModalVisible(false);
        await dispatch(fetchAllDepartments());
        setTableKey((prevKey) => prevKey + 1);
      } else {
        message.error(result.payload.error);
      }
    } catch (error) {
      console.error("Failed to delete department:", error);
      message.error("Something went wrong");
    }
  };

  const data = departments ? departments : [];

  const exportDepartments = data.map((department: any) => ({
    DepartmentName: department.Name,
    // hrId: department.hrId,
    // CreatedBy: department.CreatedBy || "N/A",
    Status: department.Status,
    CreatedDate: new Date(department.CreatedAt).toLocaleDateString(),
    TotalEmployees: department.totalEmployees ?? 0,
  }));

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [departments, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, departments]);

  const columns = [
    {
      title: "Department",
      dataIndex: "Name",
      render: (text: String, record: any) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "No of Employees",
      dataIndex: "totalEmployees",
      sorter: (a: any, b: any) => a.totalEmployees - b.totalEmployees,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}
        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <button
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditDepartment(record);
            }}
            className="me-2"
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit"
          >
            <i className="ti ti-edit" />
          </button>

          <button
            onClick={() => {
              if (!canDelete || record.Status === "inactive") return;
              setSelectedRowData(record);
              setIsDeleteModalVisible(true);
            }}
            className="me-2"
            disabled={!canDelete || record.Status === "inactive"}
            style={{
              cursor:
                !canDelete || record.Status === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity: !canDelete || record.Status === "inactive" ? 0.5 : 1,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete"
          >
            <i className="ti ti-trash" />
          </button>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Departments</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Employee</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Departments
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(exportDepartments, "department_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(exportDepartments, "department_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(exportDepartments, "department_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mb-2">
                <button
                  onClick={() => showModal("create")}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-circle-plus me-2" />
                  Add Department
                </button>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Performance Indicator list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Department List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Performance Indicator list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Department */}
      <Drawer
        title={modalType === "edit" ? "Edit Departments" : "Add Departments"}
        placement="right"
        width={400}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Department Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="department-name"
                    value={departmentName}
                    onChange={(e) => setDepartmentName(e.target.value)}
                    className="form-control"
                  />
                  {errors.Name && (
                    <div style={{ color: "red" }}>{errors.Name}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">HR</label>
                  <Select
                    isMulti
                    options={[...formattedEmployees].sort((a, b) => a.label.localeCompare(b.label))}
                    value={formattedEmployees.filter((option: any) => hrId?.includes(option.value))}
                    onChange={handleHrChange}
                    placeholder="Select HR"
                    className="basic-multi-select"
                  />
                </div>
              </div>

              {/* HR Input */}
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">Status</label>{" "}
                  <span className="text-danger ms-2">*</span>
                  <select
                    className="form-control"
                    name="employee_status"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    {DepartmentStatus?.map((status: any) => (
                      <option key={status.value} value={status.value}>
                        {status.label}
                      </option>
                    ))}
                  </select>
                  {errors.status && (
                    <small className="text-danger">{errors.status}</small>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Description
                  </label>
                  <input
                    type="text"
                    name="department-description"
                    value={departmentDescription}
                    onChange={(e) => setDepartmentDescription(e.target.value)}
                    className="form-control"
                  />
                  {errors.Description && (
                    <div style={{ color: "red" }}>{errors.Description}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-light me-2"
            >
              Cancel
            </button>
            <button type="button" onClick={handleSubmit} disabled={loading} className="btn btn-primary">
              {loading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit" ? "Update Department" : "Add Department"}
            </button>
          </div>
        </form>
      </Drawer>
      {/* /Add Department */}

      {/* delete department */}

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeleteDepartment(selectedRowData.Id)
        }
      />
    </>
  );
};

export default Department;
